import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useEffect } from "react";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { useQuery } from "@tanstack/react-query";
import { fetchWalletBalance } from "@/api/user/home";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ImgStaticCard from "@/shared/components/common/imgStaticCard/imgStaticCard";
import SkeletonCardNumber from "./skeleton";
import { toast } from "react-toastify";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import useAccountStore from "@/store/balanceStore";
import { Grid } from "@mui/material";
/**

WalletManagement

نمایش و مدیریت اطلاعات کیف پول کاربر.

نمایش موجودی کارت و شماره کارت به صورت بلوک‌بندی شده.

قابلیت کپی شماره کارت به کلیپ‌بورد.

استفاده از اطلاعات کارت‌ها از API و ذخیره در state سراسری.

در صورت عدم وجود اطلاعات، نمایش skeleton بارگذاری کارت.

@returns JSX.Element کامپوننت مدیریت کیف پول
*/
const WalletManagement = () => {
  const { setAccountData } = useAccountStore();

  const { data } = useQuery({
    queryKey: ["wallet-balance"],
    queryFn: fetchWalletBalance,
  });

  useEffect(() => {
    if (data) {
      setAccountData(data);
    }
  }, [data]);

  const cardData = data?.cards;
  const cardNumber = String(cardData?.[0]?.number || "");
  const cardChunks = cardNumber.match(/.{1,4}/g) || [];
  if (cardData && cardData.length > 0) {
    return (
      <CardKit
        width={"100%"}
        height={411}
        title={
          <StackKit direction={"row"} justifyContent={"center"}>
            <StackKit direction={"row"} gap={2}>
              <AccountBalanceWalletOutlinedIcon style={{ color: "#fff" }} />
              <TypoGraphyKit>مدیریت کیف پول</TypoGraphyKit>
            </StackKit>
          </StackKit>
        }
        sx={{
          background:"linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",
          backdropFilter: " blur(242.1999969482422px)",
          boxShadow: "-3px 0px 24px -3px #00000078",
        }}
      >
        <Grid container sx={{ display: "flex", flexDirection:'column', gap:2, justifyContent:"center", width: "100%", alignItems: "center" }}>
          <Grid size={{xs:6,sm:3,md:6}} height={'180px'} >
            <BoxKit className="w-[180px] h-[180px]" sx={{ mt: 2 }}>
                <ImgStaticCard imgSlider1="/card-out-simple-flat2.png" imgSlider2="/slide2.jpg" img1Height="180px" />
            </BoxKit>
          </Grid>
          <StackKit sx={{ width: "100%",marginTop:2 }} justifyContent={"center"} alignItems={"center"}>
            <BoxKit
              sx={{
                width: "50%",
                background: "linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
              gap={1}
            >
              <TypoGraphyKit variant="body1">
                {toPersianNumber(`${cardChunks}`)}
              </TypoGraphyKit>
              <ContentCopyIcon
                style={{ color: "#fff", cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(cardChunks.join(" "));
                  toast.success("کپی شد!", {autoClose: 2000,position: "top-right",});
                }}
              />
            </BoxKit>
          </StackKit>
        </Grid>
      </CardKit>
    );
  }
  return <SkeletonCardNumber />;
};

export default WalletManagement;
